<mat-card style="overflow: scroll; ">








    <mat-card-content >


        <div style="background: url('../../assets/img/morceau/titre.png');height: 60px; background-size: 100% 100%;
                width: 100%;color: #2F4395; font-size: 18px;">

<div style="float: left;margin-top:5px;">
    <img src="../../assets/img/morceau/3.png" height="40">
                Contenu facture Proforma
            </div>
            <div style="float: right; cursor: pointer;" (click)="clickedMe()"  >
                <img src="../../assets/img/morceau/edit.png">   
        </div> 


        </div>

        <table style=" height: 100px!important;overflow: scroll;width: 100%; "  mat-table [dataSource]="dataSource" matSort matSortActive="id"
            matSortDirection="desc" matSortDisableClear>


            <ng-container matColumnDef="designation">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Designation</th>
                <td mat-cell *matCellDef="let facturedetail">

                    {{facturedetail.designation}}</td>
            </ng-container>
            <ng-container matColumnDef="quantite">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Qnt</th>
                <td mat-cell *matCellDef="let facturedetail">

                    {{facturedetail.quantite}}</td>
            </ng-container>
            <ng-container matColumnDef="prixunit">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Prix</th>
                <td mat-cell *matCellDef="let facturedetail">

                    {{facturedetail.prixunit}} </td>
            </ng-container>

            <ng-container matColumnDef="stotal">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>S.Total</th>
                <td mat-cell *matCellDef="let facturedetail">

                    <span style="color: #05164D;">
                            &nbsp;&nbsp;&nbsp;&nbsp;{{facturedetail.prixunit*facturedetail.quantite}}
                    </span>
                </td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" style="cursor: pointer;"></tr>

        </table>



    </mat-card-content>
</mat-card>